import { type paginationProp } from "./types";
import { usePagination } from "./usePagination";
const Pagination = (props: paginationProp) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });
  let lastPage: number | string = 1;
  if (paginationRange) {
    if (currentPage === 0 || paginationRange.length < 2) {
      return null;
    }
    lastPage = paginationRange[paginationRange.length - 1];
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  return (
    <>
      <ul style={{ display: "flex", listStyleType: "none", padding: 0 ,margin:0}}>
        <li
          onClick={onPrevious}
          className={`pagination-item next ${
            currentPage === 1 ? "active" : ""
          }`}
        >
          <div className="py-1 text-sm rounded text-nowrap">{"<"}</div>
        </li>
        {paginationRange &&
          paginationRange.map((pageNumber, i) => {
            return (
              <li
                key={i}
                onClick={() => {
                  if (typeof pageNumber == "string") {
                    onPageChange(parseInt(pageNumber));
                  } else {
                    onPageChange(pageNumber);
                  }
                }}
                className={`pagination-item ${
                  currentPage === pageNumber ? "active" : ""
                } ${pageNumber == "..." ? "dots" : ""}`}
              >
                {pageNumber}
              </li>
            );
          })}
        {/* Right Navigation arrow */}
        <li
          onClick={onNext}
          className={`pagination-item next ${
            currentPage === lastPage && "active"
          }`}
        >
          <div className="py-1 text-sm rounded text-nowrap">{">"}</div>
        </li>
      </ul>
    </>
  );
};

export default Pagination;
